'use client';

import { AnimatePresence, motion } from 'framer-motion';

/**
 * Habillage plein écran du mode hardcore : un cadre rouge « respirant » autour
 * du viewport, plus un flash rouge bref quand la partie est perdue.
 * `pointer-events-none` → n'intercepte jamais les clics (grille, modales…).
 */
export function HardcoreFrame({
  active,
  justFailed,
  won = false,
}: {
  active: boolean;
  justFailed: boolean;
  /** Mot réussi : le cadre passe du rouge au vert. */
  won?: boolean;
}) {
  if (!active) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-[60]">
      <motion.div
        className="absolute inset-0 rounded-b-3xl"
        style={{
          boxShadow: won
            ? 'inset 0 0 0 4px rgba(16,185,129,0.9), inset 0 0 60px rgba(16,185,129,0.45)'
            : 'inset 0 0 0 4px rgba(220,38,38,0.9), inset 0 0 60px rgba(220,38,38,0.45)',
        }}
        animate={{ opacity: [0.7, 1, 0.7] }}
        transition={{ duration: 2.4, repeat: Infinity, ease: 'easeInOut' }}
      />

      <AnimatePresence>
        {justFailed && (
          <motion.div
            key="hardcore-fail-flash"
            className="absolute inset-0 rounded-b-3xl bg-red-600"
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 0.55, 0] }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut' }}
          />
        )}
      </AnimatePresence>
    </div>
  );
}
